export default "__VITE_ASSET__CVTE2Uz$__"